import { memo, useState } from 'react';

import { type LocationsFilterBoardTreeItemProps } from '~/components/Filters/LocationsFilter/LocationsFilterBoardTreeItem';
import { LocationsFilterHeader } from '~/components/Filters/LocationsFilter/LocationsFilterHeader';
import { LocationsFilterLibraryTree } from '~/components/Filters/LocationsFilter/LocationsFilterLibraryTree';
import { type LocationsFilterLibraryTreeItemProps } from '~/components/Filters/LocationsFilter/LocationsFilterLibraryTreeItem';
import { LocationsFilterRootBoardTree } from '~/components/Filters/LocationsFilter/LocationsFilterRootBoardTree';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';

export type LocationsFilterProps = Pick<LocationsFilterBoardTreeItemProps, 'onBoardSelect'> &
  Pick<LocationsFilterLibraryTreeItemProps, 'onLibrarySelect'>;

export const LocationsFilter = memo(({ onBoardSelect, onLibrarySelect }: LocationsFilterProps) => {
  const { libraries: librariesFlag } = usePrivateAddOnFeatures();
  const [search, setSearch] = useState('');

  return (
    <div className="-m-3 flex max-h-[calc(var(--radix-dropdown-menu-content-available-height)-150px)] flex-col overflow-y-auto">
      <LocationsFilterHeader onSearchChange={setSearch} />
      <div className="p-2">
        {librariesFlag ? (
          <LocationsFilterLibraryTree onBoardSelect={onBoardSelect} onLibrarySelect={onLibrarySelect} search={search} />
        ) : (
          <LocationsFilterRootBoardTree onBoardSelect={onBoardSelect} search={search} />
        )}
      </div>
    </div>
  );
});

LocationsFilter.displayName = 'LocationsFilter';
